<template>
  <div id="eap">
    <div class="page-header ">
      <div class="content-container row">
        <div class="page-title col-12">
          <h2>EAP UK</h2>
        </div>
        <div class="page-title col-md-12 col-lg-6">
          <p>Our Employee Assistance Programme (EAP) is a fast, effective, free and confidential programme which provides you and your family members with immediate help and support in managing any concerns that might affect your personal wellbeing. We offer unlimited access for you and your family, to a telephone helpline and a chat function available 24 hours a day, 7 days a week, 365 days a year so you never feel like support is out of reach.</p>
          <h3 class="text-white pt-2 pb-1">Call us on:</h3>
          <h3 class="text-white  py-1">Free Phone Ireland: <a class="text-white" href="tel:1800903542">1800 903 542</a></h3>
          <h3 class="text-white  pt-1 pb-2">Free Phone UK:  <a class="text-white" href="tel:08000988350">0808 196 2016</a></h3>
          <h3 class="text-white  pt-1 pb-2">International:  <a class="text-white" href="tel:0035315180277">00353 1 518 0277</a></h3>
          <div class="text-center d-flex text-md-left justify-content-md-start justify-content-center">
            <b-button class="cta-button text-md-center px-4 py-3 my-5" @click="callBack">REQUEST A CALL BACK</b-button>
          </div>
        </div>
        <div class="call-us col-md-12 col-lg-6">
          <div class="video-wrap">
            <video width="100%" class="video" controls controlsList="nodownload" src="https://healthcoach-media.com/res/videos/surge_eap_video.mp4#t=2#t=2" :poster="'/img/eap/EAP-placeholder.png'"></video>
          </div>
          </div>
      </div>
    </div>
    <div class="bg-grey py-5 px-md-5">
      <div class="content-container row">
        <div class="section-header section-header-right">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">Services Offered</h3>
        </div>
        <div v-for="(card, i) in eapCards" :key="i" class="eap-cards col-md-3 col-sm-6 mb-4 ">
          <div class="eap-card">
            <div class="row align-items-center">
              <div class="col-12 col-lg-5 pr-lg-0 text-center">
                <img class="eap-card-img bg-brand-secondary" :src="card.img_url" alt="eap-type">
              </div>
              <div class="col-12 col-lg-7 pl-1">
                <div class="eap-card-content">
                  {{ card.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white py-4 px-md-5 d-none d-lg-flex">
      <div class="content-container row support">
        <div class="section-header">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">Our Services Support</h3>
        </div>
        <div v-for="(serviceCard, i) in eapServiceCards" :key="i" class="eap-service-card col-md-5ths px-5">
          <div class="service-card-img-container">
            <img class="service-card-img" :src="serviceCard.img_url" />
          </div>
          <div class="service-card-description bran">
            {{serviceCard.title}}
          </div>
        </div>
      </div>
    </div>
    <div class="articles bg-white pb-5">
      <div class="content-container row">
        <div class="section-header section-header-right">
          <div class="section-header-divider"></div>
          <h3 class="section-header-title">Articles</h3>
        </div>
        <div v-for="(article, index) in articles" :key="index" class="col-md-3 article-wrap">
          <a class="card" @click="selectArticle(article.post_id)">
            <div class="card-header bg-brand-primary">
              <img class="card-logo" :src="'/img/' + img_type[article.post_type]" />
            </div>
            <div class="card-body" ref="cardBody">
              <p class="card-title" ref="cardTitle">{{ article.post_type }}</p>
              <div class="card-text text-eclipse">{{ article.title }}</div>
            </div>
          </a>
        </div>
        <b-link :to="{name: 'allArticles'}" class="text-link">See all articles</b-link>
      </div>
    </div>
    <div v-if="callbackSelected" class="pop-up">
      <div class="pop-up-background" @click="hidePopUp"></div>
      <div class="pop-up-content bg-brand-secondary row">
        <div class="col-12">
          <h4>EAP Call Back</h4>
          <div class="callback-form" v-if="!callBackSuccess">
            <div class="col-md-6 offset-md-3 ">
              <p>Select a service</p>
              <b-form-select class="form-control" v-model="selectedService">
                <option v-for="(service, i) in services" :key="i" :value="service.id">{{service.name}}</option>
              </b-form-select>
            </div>
            <div v-if="selectedService !== ''">
              <div class="service-description py-5 px-5">
                <p>{{ services[selectedService].content}}</p>
              </div>
              <div class="col-md-6 offset-md-3 pb-5">
                <p>Enter Phone Number</p>
                <b-input type='number' class="form-control" v-model="phoneNumber"></b-input>
              </div>
              <div class="d-flex justify-content-center">
                <b-button @click="requestCall" class="cta-button px-5 py-3"> REQUEST A CALL BACK</b-button>
              </div>
            </div>
          </div>
          <div class="callback-confirmation" v-if="callBackSuccess">
            Thank you, please expect a call back from us shortly.
          </div>
        </div>
        <b-button class="close-popup" @click="hidePopUp"><font-awesome-icon icon="times-circle"></font-awesome-icon></b-button>
      </div>
    </div>
  </div>
</template>

<script>
    // @ is an alias to /src
    import axios from "axios";
    import config from "@/constants";
    export default {
        name: "eap",
        components: {},
        data() {
            return {
                callbackSelected: false,
                selectedService: '',
                phoneNumber:'',
                callBackSuccess: false,
                pageData: {},
                articles: [],
                img_type: {
                    video: "video-white.svg",
                    text: "blog-white.svg",
                    image: "far fa-image",
                    audio: "podcast-white.svg"
                },
                eapCards:[
                    {
                        title: 'Mental wellbeing support',
                        img_url: '/img/eap/mental-wellbeing-support.svg'
                    },
                    {
                        title: 'Financial assistance',
                        img_url: '/img/eap/financial-assistance.svg'
                    },
                    {
                        title: 'Life coaching',
                        img_url: '/img/eap/life-coaching.svg'
                    },
                    {
                        title: 'Career counselling',
                        img_url: '/img/eap/career-counselling.svg'
                    },
                    {
                        title: 'Consumer adviser',
                        img_url: '/img/eap/consumer-advisor.svg'
                    },
                    {
                        title: 'Mediation',
                        img_url: '/img/eap/mediation.svg'
                    },
                    {
                        title: 'Support for non-nationals & their families',
                        img_url: '/img/eap/support-non-irish-national.svg'
                    },
                    {
                        title: 'Legal assistance',
                        img_url: '/img/eap/legal-assistance.svg'
                    },

                ],
                eapServiceCards:[
                    {
                        title: 'Depression, anxiety & stress',
                        img_url: '/img/eap/service-img/depression.svg'
                    },
                    {
                        title: 'Grief & bereavement',
                        img_url: '/img/eap/service-img/grief.svg'
                    },
                    {
                        title: 'Addictions',
                        img_url: '/img/eap/service-img/addiction.svg'
                    },
                    {
                        title: 'Relationship & marital problems',
                        img_url: '/img/eap/service-img/relationship.svg'
                    },
                    {
                        title: 'Work stress & work-life balance issues',
                        img_url: '/img/eap/service-img/work-stress.svg'
                    },
                ],
                services:[
                    { id: 0, name: 'Financial Assistance', content: "Our Qualified Financial Advisors are available to provide timely and informed guidance around money worries or queries. They can provide consultation on a wide range of financial issues from budgeting and investing, right through to investing and preparing for your retirement."},
                    { id: 1, name: 'Legal Assistance', content: "If you face a legal situation or have a question on a legal issue that you would like to discuss with a trained legal professional, our EAP can provide consultations with a team of solicitors who can provide assistance for a wide range of legal issues."},
                    { id: 2, name: 'Life Coaching', content: "Life Coaching can help to promote self-awareness, enhance skills and clarify visions, intentions and goals. Whilst not to be confused with counselling, life coaching is appropriate for those who are ready to take action in their lives and can be valuable during times of personal or professional change."},
                    { id: 3, name: 'Career Counselling', content: "The EAP can assist you in the planning, management and development of jobs, careers and occupations. Our case managers can connect you with a career coach who can discuss how coaching could help you to achieve excellence through customised career development solutions and training."},
                    { id: 4, name: 'Consumer Advice', content: "Our EAP team are trained to identify any consumer issues that you may have. Understanding your rights as a consumer is key to safeguarding those rights. We will direct you towards the relevant information or experts, ensuring that you are fully informed of your rights and legal stand point as a consumer."},
                    { id: 5, name: 'Mediation', content: "Mediation is a confidential, flexible, voluntary, impartial and informal approach to conflict resolution. Our mediation information service is aimed at helping you figure out if mediation could help find a mutually acceptable resolution to a conflict you may be facing, whether it may be in your own workplace, or with a third party."},
                    { id: 6, name: 'Support for Non-Nationals', content: "For non-nationals and their families, making a smooth transition into a new country can be daunting. Our team can provide information and guidance on a range of issues including finance, education, health services, entitlements, and many more. We can help ensure you and your family are ready for any potential obstacles when settling into your new life."},
                    { id: 7, name: 'Mental Wellbeing Support', content: "Our expertly trained team are on hand 24/7 to provide advice and guidance on a wide range of everyday services and issues relating to areas such as the home, family, childcare or travelling. We can assist directly or refer you to experts or services in each area along with providing information and resources relevant to your individual case."},
                ],
            };
        },
        mounted() {
            this.getResourceList()
            window.$zopim ? window.$zopim.livechat.button.show() : this.enableZendeskWidget()
        },
        destroyed(){
          //remove zendesk
          window.$zopim.livechat.hideAll()
        },
        methods: {
            callBack(){
                this.callbackSelected = true
            },
            async getResourceList(){
                const payload = {
                    user_id: "LayaEAP",
                    "search_key":"",
                    "filter":"",
                    "tag":"mind",
                    "fav_only":"0",
                    "page":"0",
                    "page_size":"4",
                    "surge_only":1
                }
                let res= await axios.post(config.api_env + '/application/api-hc/get-all-resource-list', payload, config.options)
                if(res.data.success){
                    this.articles = res.data.resources
                }

            },
            selectArticle(articleId){
                this.$router.push('/wellbeing/article/'+ articleId)
            },
            async requestCall(){
                let payload = {
                    user_id: "LayaEAP",
                    phone: this.phoneNumber,
                    service_id: this.selectedService
                }
                let res = await axios.post(config.api_env + '/application/api-hc/send-eap-request', payload, config.options)
                if(res.data.sent){
                    this.callBackSuccess = true
                }
            },
            hidePopUp(){
                this.callbackSelected = false
                this.selectedService = ''
                this.callBackSuccess = false
            },
            enableZendeskWidget(){
                window.$zopim||(function(d,s){
                    var z = window.$zopim = function(c){
                            z._.push(c)
                        },
                        $ = z.s = d.createElement(s), e = d.getElementsByTagName(s)[0];
                    z.set = function(o){
                        z.set._.push(o)
                    };
                    z._ = [];
                    z.set._ = [];
                    $.async=!0;
                    $.setAttribute("charset","utf-8");
                    $.setAttribute("id","zendesk");
                    $.src="https://v2.zopim.com/?3okxX0ixGGb6EMgCdyN36VEHZseWQFwl";
                    z.t=+new Date;
                    $.type="text/javascript";
                    e.parentNode.insertBefore($,e)
                })(document,"script");

            }
        },
        watch:{
        }
    };
</script>
<style lang="less">
  @import "../assets/_theme-0";
  #eap {
    .page-header {
      padding: 60px 0;
      .page-title {
        text-align: left;
        h2 {
          text-align: left;
          font-size: 3.8rem;
          letter-spacing: 0.7rem;
          font-family: "FilsonProBold", sans-serif;
          color: #fff;
        }
        p{
          font-size: 2.2rem;
          font-family: 'FilsonProBook';
          color: #fff;
        }
      }
      .call-us{
        text-align: right;
        img{
          max-width: 220px;
        }
        h3 {
          font-family: 'FilsonProLight';
          font-size: 3.5rem;
          letter-spacing: 0;
          color: #fff;
          font-weight: 100;
          padding-top: 20px;
        }
        .btn{
          font-size: 1.3rem;
          font-family: 'FilsonProBold';
        }
      }
      .video-wrap {
        border-radius: 20px;
        -o-object-fit: fill;
        object-fit: fill;
        .video {
          -o-object-fit: fill;
          object-fit: fill;
          border-radius: 20px;
          &:focus {
            outline: none;
          }
        }
      }
    }
    .eap-cards{
      .eap-card {
        .eap-card-img {
          border-radius:50%;
          width: 100%;
          height: 100%;
          max-width: 100px;
        }
        .eap-card-content{
          font-family: FilsonProLight, sans-serif;
          font-size: 2.1rem;
          line-height: 2.3rem;
          letter-spacing: 0;
        }
      }
    }
    .eap-service-card {
      &:not(:last-of-type)::after {
        content: "";
        position: absolute;
        top: 70%;
        right: 0;
        width: 1px;
        height: 30%;
        transform: translateY(-50%);
        background: #cccccc;
      }
      .service-card-img-container{
        height: 90px;
        .service-card-img{
          height: 90px;
          transform: translateX(25%);
          width: 65%;
          z-index: 2;
        }
      }
      .service-card-description{
        font-family: FilsonProBook, sans-serif;
        margin-top: 20px;
        font-size: 1.8rem;
        line-height: 1.2;
        text-align: center;
        letter-spacing: 0;
      }
    }
    .support{
      padding-bottom: 80px;
    }
    .pop-up{
      display: flex;
      align-items: center;
      z-index: 500;
      position:fixed;
      top:0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      text-align: center;
      overflow-y: scroll;
      .pop-up-content{
        max-width: 636px;
        width: 100%;
        margin: auto;
        border-radius: 25px;
        padding: 50px 20px;
        font-size: 1.6rem;
        text-align: center;
        z-index: 10;
        color: #fff;
        position: relative;
        p{
          color: #fff;
        }
        h4{
          font-family: 'FilsonProBold', sans-serif;
          font-size: 3.8rem;
          color: #fff;
        }
        .form-control{
          height: 30px;
          border-radius: 5px;
          font-size: 1.6rem;
        }
        .service-description{
          text-align: left;
        }
        .close-popup{
          position: absolute;
          top: 0;
          right: 0;
          background-color: transparent;
          width: 50px;
          height:50px;
          svg{
            width: 30px;
            height: 30px;
          }
        }
      }
      .pop-up-background{
        width: 100vw;
        height: 100vh;
        position: absolute;
        left: 0;
        right: 0;
        z-index: 5;
        background: transparent;
      }
    }
    .articles();
  }
</style>
